import DebugView from '@/debug/DebugView.vue'
import {registerRoute} from '@/router'
import {DebugFeature} from '@/debug/feature-toggles'

export const DEBUG = {
        componentName: 'Debug',
        component: DebugView,
        meta: {requiresOrg: true}
}
if(DebugFeature.isEnabled())
    registerRoute(DEBUG)
